import { Dispatch } from 'redux';
import backend from '../../../apis/backend';
import { ReduxState } from '../../state';
import { 
  getUserOrdersSuccess,
  getUserOrdersFailure
} from '../actions';
import { UserOrder } from '../types';

// Initiator for fetching user orders
export const fetchUserOrders = (userId: string, more: boolean = false) => {
  return async (dispatch: Dispatch, getState: () => ReduxState) => {
    try {
      // Get the loginToken from the Redux state
      const { auth } = getState();
      const loginToken = auth.loginToken;
      const { userOrders, userOrdersDetails } = getState().user;
      let fetchedUserOrders: UserOrder[] = [];
      // Construct the headers with X-Auth-Token
      const headers = {
        'X-Auth-Token': loginToken,
      };

      let url = `/commerce-service/api/v1/orders?userId=${userId}&limit=10&sortBy=createdAt&sortDirection=desc`
      if (more && userOrdersDetails.currentPage) {
        const nextPage = userOrdersDetails.currentPage + 1
        url += `&page=${nextPage}`
      }
      const response = await backend.get(url,{ headers });

      if (response.status === 200) {
        const { totalItems, currentPage, totalPages } = response.data;
        const details = { totalItems, currentPage, totalPages }
        if (more) {
          fetchedUserOrders = [...userOrders].concat(response.data.orders)
        } else {
          fetchedUserOrders = response.data.orders
        }
        dispatch(getUserOrdersSuccess({ orders: fetchedUserOrders, details }));
      } else {
        dispatch(getUserOrdersFailure('Failed to fetch user orders.'));
      }
    } catch (error) {
      console.error('Error fetching user orders:', error);
      dispatch(getUserOrdersFailure('An error occurred while fetching user orders.'));
    }
  };
};